export default "__VITE_ASSET__Do127CqG__"